enum UxBrandEnum {
  EDGENUITY = "assets:icons/edgenuity.svg",
  MYPATH = "assets:icons/my-path-logo.svg",
  IMAGINELEARNING = "assets:icons/ImagineLearning.svg",
  IMAGINEMYPATH = "assets:icons/ImagineMypath.svg"
}
export default UxBrandEnum;
